export const TALK_TIMES = [
    {value: '0', label: 'Any Talk Time'},
    {value: '15', label: 'Greater than 15 seconds'},
    {value: '30', label: 'Greater than 30 seconds'},
    {value: '60', label: 'Greater than 60 seconds'},
    {value: '90', label: 'Greater than 90 seconds'},
    {value: '120', label: 'Greater than 2 minutes'},
    {value: '300', label: 'Greater than 5 minutes'}
]
